import { Direction } from "@microsoft/fast-web-utilities";
import { withDefaults } from "@microsoft/fast-jss-utilities";
import { isFunction } from "lodash-es";
import { white } from "../utilities/color/color-constants";
import { accentPalette, neutralPalette } from "../default-palette";
import designSystemSchema from "./design-system.schema";
export const defaultFontWeights = {
    light: 100,
    semilight: 200,
    normal: 400,
    semibold: 600,
    bold: 700,
};
export { designSystemSchema };
const designSystemDefaults = {
    backgroundColor: white,
    contrast: 0,
    density: 0,
    designUnit: 4,
    baseHeightMultiplier: 8,
    baseHorizontalSpacingMultiplier: 3,
    direction: Direction.ltr,
    cornerRadius: 2,
    elevatedCornerRadius: 4,
    focusOutlineWidth: 2,
    fontWeight: defaultFontWeights,
    disabledOpacity: 0.3,
    outlineWidth: 1,
    neutralPalette,
    accentPalette,
    accentBaseColor: "#0078D4",
    /**
     * Recipe Deltas
     */
    accentFillRestDelta: 0,
    accentFillHoverDelta: 4,
    accentFillActiveDelta: -5,
    accentFillFocusDelta: 0,
    accentFillSelectedDelta: 12,
    accentForegroundRestDelta: 0,
    accentForegroundHoverDelta: 6,
    accentForegroundActiveDelta: -4,
    accentForegroundFocusDelta: 0,
    neutralFillRestDelta: 7,
    neutralFillHoverDelta: 10,
    neutralFillActiveDelta: 5,
    neutralFillFocusDelta: 0,
    neutralFillSelectedDelta: 7,
    neutralFillInputRestDelta: 0,
    neutralFillInputHoverDelta: 0,
    neutralFillInputActiveDelta: 0,
    neutralFillInputFocusDelta: 0,
    neutralFillInputSelectedDelta: 0,
    neutralFillStealthRestDelta: 0,
    neutralFillStealthHoverDelta: 5,
    neutralFillStealthActiveDelta: 3,
    neutralFillStealthFocusDelta: 0,
    neutralFillStealthSelectedDelta: 7,
    neutralFillToggleHoverDelta: 8,
    neutralFillToggleActiveDelta: -5,
    neutralFillToggleFocusDelta: 0,
    baseLayerLuminance: -1,
    neutralFillCardDelta: 3,
    neutralForegroundDarkIndex: 93,
    neutralForegroundLightIndex: 0,
    neutralForegroundHoverDelta: 0,
    neutralForegroundActiveDelta: 0,
    neutralForegroundFocusDelta: 0,
    neutralDividerRestDelta: 8,
    neutralOutlineRestDelta: 25,
    neutralOutlineHoverDelta: 40,
    neutralOutlineActiveDelta: 16,
    neutralOutlineFocusDelta: 25,
};
/**
 * Ensure that all properties of the DesignSystem are assigned.
 */
export const withDesignSystemDefaults = (config) => withDefaults(designSystemDefaults)(config);
/**
 * Safely retrieves a single property from a DesignSystem.
 * @deprecated Use getDesignSystemValue instead.
 */
export function getDesignSystemProperty(key) {
    return function (config) {
        return withDesignSystemDefaults(config)[key];
    };
}
/**
 * Returns the argument if basic, otherwise calls the DesignSystemResolver function.
 *
 * @param arg A value or a DesignSystemResolver function
 * @param designSystem The design system config.
 */
export function checkDesignSystemResolver(arg, designSystem) {
    return isFunction(arg) ? arg(designSystem) : arg;
}
/**
 * Returns a function that calls the callback with designSystemDefaults ensured.
 * @deprecated - use design system property accessor functions instead
 */
export function ensureDesignSystemDefaults(callback) {
    return (designSystem) => {
        return callback(withDesignSystemDefaults(designSystem));
    };
}
export default designSystemDefaults;
